module.exports = __webpack_public_path__ + "img/logo.1e0d98f2.svg";